import { QuoteFormField } from '~/components/quote-form/quote-form.schema';

import { useFilledQuoteFormValuesCurrentPetFormValues } from '~/hooks/insurance-data-provider/useFilledQuoteFormValuesCurrentPetFormValues';

export function useFilledQuoteFormValuesField(fieldName: QuoteFormField) {
  const quoteFormValues = useFilledQuoteFormValuesCurrentPetFormValues();

  return quoteFormValues[fieldName];
}
